<template>
  <fo-layout class="practice-model">
    <span slot="alt" v-if="headlineText[2]">{{headlineText[2].sub_title}}</span>
    <span slot="title" v-if="headlineText[2]">{{headlineText[2].title}}</span>
    <div class="card-layout" v-if="data.length">
      <a-row :gutter="30">
        <a-col :sm="8" v-for="(item, ind) in data" :key="ind">
          <div class="padding-layout">
            <card
              class="card-shadow"
              :imgurla="item.card_icon_active"
              :imgurlb="item.card_icon_default"
              :title="item.card_title"
              :info="item.card_intro"
              @click="goToDtl(item.card_link_url)">
            </card>
          </div>
        </a-col>
      </a-row>
      <div class="more-btn">
        <a-button class="fo-small-btn" @click="goToMore">查看更多</a-button>
      </div>
    </div>
    <div class="card-layout" v-else>
      <a-row :gutter="30">
        <a-col :sm="8" v-for="(item, ind) in 3" :key="ind">
          <div class="padding-layout">
            <card class="card-shadow"></card>
          </div>
        </a-col>
      </a-row>
    </div>
  </fo-layout>
</template>

<script>
import card from './comps/cardAreas.vue'
export default {
  components: {
    card
  },
  data () {
    return {
      loading: false,
      data: [],
      // 标题文字
      headlineText: [],
      cond: {
        page_num: '1',
        page_size: '3'
      }
    }
  },
  watch: {
    '$route' (obj) {
      if (obj.params.param) {
        window.scroll(0, 0)
      }
    }
  },
  mounted () {
    this.readList()
    this.readItems()
  },
  methods: {
    /**
     * 页头、页脚公用信息查询
     */
    readItems () {
      this.get({
        url: 'configFind',
        data: {
          key: 'web_pages'
        }
      }, (r) => {
        if (r.code) {
          var data = JSON.parse(r.data.value)
          for (var i of data) {
            if (i.label_en === 'home' || i.label_zh === '网站首页') {
              this.headlineText = i.children
            }
          }
        } else {
          this.error(r.msg)
        }
      })
    },
    readList () {
      this.loading = true
      this.get({
        url: 'cardRead',
        data: this.cond
      }, (res) => {
        this.loading = false
        this.data = res.data.items
      })
    },
    goToMore () {
      window.scroll(0, 0)
      this.$router.push('./practice')
    },
    goToDtl (router) {
      window.scroll(0, 0)
      this.$router.push(router)
    }
  }
}
</script>

<style lang="less">
@media screen and (max-width: 751px) and (min-width: 300px) {
  .example3 {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 500px 50px;
    margin: 20px 0;
  }
  .practice-model {
    .card-layout {
      padding-top: 20px;
    }
    .more-btn {
      text-align: center;
      margin-top: 14px;
    }
    .padding-layout {
      padding-bottom: 16px;
    }
  }
}
@media screen and (min-width: 751px) {
  .example3 {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 300px 50px;
    margin: 20px 0;
  }
  .practice-model {
    .card-layout {
      padding-top: 50px;
    }
    .more-btn {
      text-align: center;
      margin-top: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/practice.vue